import React, { useState } from 'react';
import Slider from 'react-slick';
import Lightbox from './Lightbox';

// Foto curate della struttura — orizzontali, non i WhatsApp verticali
import img1 from '../images/header.jpeg';
import img2 from '../images/outside/alma_suite_bb_outside.jpg';
import img3 from '../images/outside/alma_suite_bb_living_room.jpg';
import img4 from '../images/outside/alma_suite_bb_outside_house.jpg';
import img5 from '../images/outside/outside-new-1.jpeg';
import img6 from '../images/outside/outside-new-2.jpeg';

const imageList = [img1, img2, img3, img4, img5, img6];

function HousePhoto() {
    const [lightboxIndex, setLightboxIndex] = useState(null);

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2800,
        pauseOnHover: false,
        responsive: [
            { breakpoint: 900, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 540, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ]
    };

    return (
        <section id="housePhotos">
            <Slider {...settings}>
                {imageList.map((src, index) => (
                    <div
                        key={index}
                        className="house-slide"
                        onClick={() => setLightboxIndex(index)}
                    >
                        <img
                            src={src}
                            alt={`B&B Alma Suite Anzio ${index + 1}`}
                        />
                    </div>
                ))}
            </Slider>

            {lightboxIndex !== null && (
                <Lightbox
                    images={imageList}
                    initialIndex={lightboxIndex}
                    onClose={() => setLightboxIndex(null)}
                />
            )}
        </section>
    );
}

export default HousePhoto;
